/**
 * The Monday planning point (21 §10, 08 §3): a short, skippable checklist on the Office screen.
 * It never blocks play; "Not now" hides it for this week in this browser.
 */
export function PlanningPrompt({ busy, unread, onGo, onDone, onDismiss }: {
  busy: boolean; unread: number;
  onGo: (panel: "diary" | "instructions" | "inbox") => void; onDone: () => void; onDismiss: () => void;
}) {
  return (
    <aside className="planning" aria-labelledby="planning-title">
      <h2 id="planning-title" className="planning__title">Plan your week</h2>
      <p className="muted">It's Monday. A few minutes now can shape the rest of the week. All of this is optional.</p>
      <ul className="planning__list">
        <li><button type="button" className="link-btn" onClick={() => onGo("diary")}>Protect time in the diary</button> for design work, email or a one-to-one.</li>
        <li><button type="button" className="link-btn" onClick={() => onGo("instructions")}>Review standing instructions</button> for requests that keep coming back to you.</li>
        <li><button type="button" className="link-btn" onClick={() => onGo("inbox")}>Triage the inbox</button>{unread > 0 ? ` (${unread} unread).` : "."}</li>
      </ul>
      <div className="row-actions">
        <button type="button" className="btn btn--primary" disabled={busy} onClick={onDone}>Done planning</button>
        <button type="button" className="btn btn--quiet" onClick={onDismiss}>Not now</button>
      </div>
    </aside>
  );
}
